export const ERROR = 1
export const FETCH_COMPLETED = 2
export const PUSH_COMPLETED = 3
export const DELETE_COMPLETED = 4
export const UPDATE_COMPLETED = 5
export const SET_CURRENT_TYPE = 6
export const SET_HISTORY = 7
export const SET_CURRENT_ITEM = 8
export const SET_SHOW_EDIT_RECEIVER = 9
export const SET_BILL_GET_ALL_PARAMS=10
export const EXPORT_COMPLETED = 11
export const SUB_ERROR = 12
export const GET_BILL_COMPLETED = 13
export const CLEAR = 14
export const GET = 1
export const POST = 2
export const PUT = 3
export const DELETE = 4